<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Name" formControlName="name">
    <form-group-simple name="name" placeholder="Name"></form-group-simple>
  </form-group-context>

  <form-group-context label="Description" formControlName="description">
    <form-group-simple type="textarea" name="description" placeholder="Tell me about your awesome app"></form-group-simple>
  </form-group-context>

  <form-group-context label="Key" formControlName="key">
    <form-group-simple name="key" placeholder="Key"></form-group-simple>
  </form-group-context>

  <form-group-context label="Apple package name" formControlName="applePackageName">
    <form-group-simple name="applePackageName" placeholder="name"></form-group-simple>
  </form-group-context>

  <form-group-context label="Google package name" formControlName="googlePackageName">
    <form-group-simple name="googlePackageName" placeholder="Name"></form-group-simple>
  </form-group-context>


  <form-group-context label="App keys"
                      *ngIf="form.get('storeKey')"
                      formControlName="storeKey">
    <form-group-select entity="storeKey"
                       bindLabel="name"
                       [searchable]="true"
                       [storeQuery]="null"
                       bindValue="id"
                       placeholder="App key"></form-group-select>
  </form-group-context>

  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
